// src/views/EjecucionesManuales/ReinicioSaldoDeTarjetas/ReinicioSaldoDeTarjetas.jsx
import React from "react";
import EjecutarProceso from "../../EstadosFlujos/Procesos/EjecutarProceso";

export default function ReinicioSaldoDeTarjetas({ onRedirect }) {
  return (
    <EjecutarProceso
      procesoId={11}
      titulo="Reiniciar Saldos de Tarjetas"
      redirectView="listaTarjetas"   // ⬅️ EXACTO
      onRedirect={onRedirect}
    />
  );
}
